import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Button, TextInfo, LoadingIndicator } from '@components';

import './styles.css';
import { EmprestimoService } from '../../../common/services/emprestimo';

const service = new EmprestimoService();

export const ImpostoDeRendaPage = () => {
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState({
    penultimoSaldoDevedor: '',
    penultimoValorTotalPago: '',
    ultimoSaldoDevedor: '',
    ultimoValorTotalPago: '',
  });
  const anoPassado = new Date().getFullYear() - 1;
  const anoRetrasado = new Date().getFullYear() - 2;

  const navigate = useNavigate();
  const {
    data: { matricula, token } = { matricula: '', token: '' },
    dadosPessoais: { nome } = { nome: '' },
  } = useSelector((state) => state.user);

  useEffect(() => {
    service
      .obterDadosImpostoDeRenda(matricula, token)
      .then((res) => {
        setDados(res);
      })
      .finally(() => setLoading(false));
  }, [matricula, token]);

  return loading ? (
    <LoadingIndicator />
  ) : (
    <>
      <Helmet>
        <title>Forluz - Imposto de renda</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Imposto de renda</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <h3>
            {matricula} - {nome}
          </h3>
          <div className="imposto-grid mt-3">
            <TextInfo
              text={`Saldo total devedor no ano de ${anoRetrasado}`}
              info={dados.penultimoSaldoDevedor}
            />
            <TextInfo
              text={`Valor total pago no ano de ${anoRetrasado}`}
              info={dados.penultimoValorTotalPago}
            />

            <TextInfo
              text={`Saldo total devedor no ano de ${anoPassado}`}
              info={dados.ultimoSaldoDevedor}
            />
            <TextInfo
              text={`Valor total pago no ano de  ${anoPassado}`}
              info={dados.ultimoValorTotalPago}
            />
          </div>
        </div>
      </div>
    </>
  );
};
